import {ChartEventOutcomeDomainModel} from "./chart-event-outcome.domain-model";
import {BaseViewModel} from "../../../../../infrastructure/models/base-view-model";

export class ChartEventOutcomeViewModel extends BaseViewModel {
  domainModel: ChartEventOutcomeDomainModel

  constructor(model: ChartEventOutcomeDomainModel) {
    super(model);

    this.x = model.x;
    this.y = model.y;
    this.z = model.z;
  }

  get hasShotCoordination(): Boolean {
    return (this.x || this.y || this.z );
  }
}
